import { ClearBaseIcon } from '@tableau/icons/ClearBaseIcon';
import { ButtonType, ButtonWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { InteractiveModalDialog } from '../styles/StarterStyles';

export interface StartersModalCloseButtonProps {
  handleClick: () => void;
  tooltipText: string;
}

export class StartersModalCloseButton extends React.PureComponent<StartersModalCloseButtonProps> {

  render() {
    return (
      <div className={InteractiveModalDialog.CloseButtonContainer}>
        <Tooltip
          afterDelay
          position={TooltipPosition.Right}
          testId={'starters-modal-close-tooltip'}
          tooltipContent={this.props.tooltipText}
        >
          <ButtonWidget
            buttonType={ButtonType.LowEmphasis}
            onClick={this.props.handleClick}
            testId={'starters-modal-close'}
            className={InteractiveModalDialog.CloseButtonStyleName}
          >
            <ClearBaseIcon size={24} alt={Messages.acceleratorsCloseButtonAltText()} />
          </ButtonWidget>
        </Tooltip>
      </div>
    );
  }
}
